import { ExtendUserProductSubscriptionPayload } from '@/store/modules/subscription/subscription.state';
import { axios } from './axios';

export const subscriptionApi = {
  async getMySubscriptions() {
    return axios.get('me/subscriptions');
  },
  async extendUserProductSubscription(
    data: ExtendUserProductSubscriptionPayload
  ) {
    return axios.post(`subscriptions/${data.userApplicationId}`, data);
  }
};
